<template>
  <div class="assetDetailTagsProperties">
    <div class="assetDetailTagsProperties-title">
      <h4>Properties</h4>
    </div>
    <div class="assetDetailTagsProperties-content">
      <div class="assetDetailTagsProperties-keySection"
        v-for="property in properties"
        :key="property.name"
      >
        <div class="assetDetailTagsProperties-keySection-title">
          <h5>{{ property.name }}</h5>
        </div>
        <div class="assetDetailTagsProperties-keySection-values">
          <pill v-for="value in getValuesForKey(property.name)"
            :key="value"
          >
            {{ value }}
          </pill>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pill from './Pill.vue'
import { onMounted, inject } from '@vue/composition-api'
import { uniq } from 'lodash'
import store from '@/store'

export default {
  name: 'AssetDetailTagsProperties',

  components: {
    Pill
  },

  props: {
    pageUrlId: {
      type: String,
      required: true
    }
  },

  setup (props) {
    const assetProperties = inject('assetProperties')
    const properties = inject('properties')
    const brandId = store.state.brand.settings.id

    const loadProperties = async () => {
      await properties.loadList({ brandId })
    }
    const loadAssetProperties = async () => {
      await assetProperties.loadList({ brandId, assetId: props.pageUrlId })
    }

    const getValuesForKey = propertyName => uniq(
      assetProperties.list.value
        .filter(p => p.property__name === propertyName)
        .map(p => p.value)
    )

    onMounted(async () => {
      await Promise.all([
        loadProperties(),
        loadAssetProperties()
      ])
    })

    return {
      properties: properties.list,
      getValuesForKey
    }
  }
}
</script>

<style lang="scss">
@import '../Nebula/style.scss';

.assetDetailTagsProperties {
  h5 {
    margin: 0;
  }

  &-title {
    border-bottom: 1px solid $very-light-pink;
    padding-bottom: 5px;
    margin-bottom: 10px;

    h4 {
      font-family: $defaultFont;
      font-size: 12px;
      color: $slate-grey;
      margin: 0;
      font-weight: 400;
    }
  }

  &-keySection {
    margin-bottom: 15px;

    &-values {
      display: flex;
      flex-wrap: wrap;
      column-gap: 5px;
      row-gap: 5px;
      padding-top: 10px;
    }
  }
}
</style>
